/** Metadados únicos do documento impresso do Design System. */
export const DOC_NAME = 'Design System — Sistema TEG';
export const DOC_VERSION = 'v2';

/** Número de seção com dois algarismos, como no sumário: `01`, `12`. */
export function numeroDaSecao(numero: number): string {
  return String(numero).padStart(2, '0');
}

/**
 * Nome sugerido do arquivo, no formato `Design System TEG v2 - 02_10_2026`.
 * Vira o `document.title` durante a impressão: é o nome que o navegador
 * propõe ao salvar como PDF.
 */
export function buildPrintFileName(date = new Date()): string {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `Design System TEG ${DOC_VERSION} - ${dd}_${mm}_${yyyy}`;
}
